'use client';

import { Suspense, useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import { captureReferralCode } from '@/lib/referral-attribution';

function ReferralCaptureInner() {
  const searchParams = useSearchParams();

  useEffect(() => {
    const ref = searchParams.get('ref') || searchParams.get('REF');
    if (ref) {
      console.log('[Referral] Captured ref param:', ref);
      captureReferralCode(ref);
    }
  }, [searchParams]);

  return null;
}

/**
 * Global component that captures ?ref= URL parameter into localStorage.
 * Wrapped in Suspense for Next.js 15 useSearchParams compatibility.
 */
export default function ReferralCapture() {
  return (
    <Suspense fallback={null}>
      <ReferralCaptureInner />
    </Suspense>
  );
}
